export function assertDefined<T>(value?: T | null, message?: string): asserts value is T {
  if (typeof value === 'undefined' || value === null) {
    throw Error(
      `This should never happen, assertion failed value is undefined when it was assumed never to be: ${message}`
    );
  }
}

export function assertValueIsOfType<T>(value: any, action: () => boolean, message?: string): asserts value is T {
  if (action() !== true) {
    throw Error(`Assertion Failed: ${message ?? 'something was not the right type when it needs to be'}`);
  }
}
